<footer id="footer" class="footer" [ngClass]="{'full-height-company': isFullPageCompany,
                                                'full-height-reels': isFullPageReel,
                                                'is-full-height': isFullPageCompany || isFullPageReel}" *ngIf="footer">
    <div class="footer-wrapper">
        <div *ngIf="screenWidth > 1024" class="footer-content-wrapper">
            <p class="heading5 connect-footer" [ngClass]="{'fade-content':fadeContent}" [innerHtml]="footer.header"></p>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-4 col-12">
                        <div class="row">
                            <div class="w-100">
                                <div class="content-wrapper" [ngClass]="{'fade-content':fadeContent}" >
                                    <h1 class="heading1 font-bold heading1-m f-white" [innerHtml]="footer.title"></h1>
                                    <p class="paragraph1 font-light heading3-m f-white" [innerHtml]="footer.description"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-8 col-12">
                        <div class="row">
                            <div class="col-lg-4 col-6">
                                <div class="row">
                                    <div class="w-100">
                                        <div class="footer-list-container go-to-wrapper" [ngClass]="{'fade-content':fadeContentMenus}">
                                            <h3 class="heading3 f-normal f-white" >Go to</h3>
                                            <ul class="footer-list">
                                                <li class="footer-menu-links" *ngFor="let menu of menus"><a target="{{menu.target}}" class="link4 link-darker" [ngClass]="{'active': activePage == menu.title.toLowerCase()}" (click)="handleRouterLink(menu.url)">{{menu.title}}</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>  
                            <div class="col-lg-4 col-12">
                                <div class="row">
                                    <div class="w-100">
                                        <div class="footer-list-container" [ngClass]="{'fade-content':fadeContentSocials}">
                                            <h3 class="heading3 f-normal f-white">Get in touch</h3>
                                            <a class="address-link link5 link-darker" href="mailto:{{footer.email}}">{{footer.email}}</a>
                                            <br>
                                            <a class="address-link address-p link4 link-darker" target="_blank" href="https://goo.gl/maps/5W6KZD7RKnaG7ZfP8" [innerHtml]="footer.address"></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-6">
                                <div class="row">
                                    <div class="w-100">
                                        <div class="footer-list-container" [ngClass]="{'fade-content':fadeContentLink}">
                                            <h3 class="heading3 f-normal f-white">Follow us</h3>
                                            <ul class="footer-list footer-menu-socials">
                                                <li class="footer-menu-socials-links" *ngFor="let social of socials"><a target="{{social.target}}" class="link1 link-white" href="{{social.url}}" >{{social.title}}</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="screenWidth <= 1024" class="footer-content-wrapper">
            <div class="container-fluid center-container">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="w-100">
                                <div class="content-wrapper" [ngClass]="{'fade-content':fadeContent}">
                                    <p class="heading5 connect-footer" [innerHtml]="footer.header"></p>
                                    <h1 class="heading1 font-bold heading-1-t heading-2-3-m f-white" [innerHtml]="footer.title"></h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <div class="w-100">
                                        <div class="footer-list-container footer-emails" [ngClass]="{'fade-content':fadeContentLink}">
                                            <h3 class="heading3 heading-3-m f-normal f-white">Get in touch</h3>
                                            <a class="address-link link1-mobile link-dustgray" href="mailto:{{footer.email}}">{{footer.email}}</a>
                                            <a class="address-link address-p link4 f-dustgray d-block" target="_blank" href="https://goo.gl/maps/5W6KZD7RKnaG7ZfP8" [innerHtml]="footer.address"></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="w-100">
                                        <div class="footer-list-container footer-socials" [ngClass]="{'fade-content':fadeContentSocials}">
                                            <h3 class="heading3 heading-3-m f-normal f-white">Follow us</h3>
                                            <ul class="footer-list">
                                                <li class="footer-menu-socials-links" *ngFor="let social of socials"><a target="{{social.target}}" class="link1-mobile link-dustgray" href="{{social.url}}"  >{{social.title}}</a></li>
                                            </ul>
                                        </div>
                                     
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="w-100">
                                        <div class="copyright-content" [ngClass]="{'fade-content':fadeContentCopyright}">
                                            <p class="paragraph2 float-left f-dustgrey">© {{year}}&nbsp;</p>
                                            <div class="paragraph2 f-dustgrey copyright-by">by Pulla.</div>
                                            <div class="paragraph2 f-dustgrey" [innerHtml]="footer.powered"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div  *ngIf="screenWidth <= 1024" class="go-to-top-link d-none d-md-block"><a class="link1-mobile link-white" (click)="goToTop()">Go to top</a></div>
        <div *ngIf="screenWidth > 1024" class="footer-bottom-content" [ngClass]="{'fade-content':fadeContentLink}">
            <div class="copyright-content">
                <p class="paragraph2 float-left f-dustgrey">© {{year}}&nbsp;</p>
                <div class="paragraph2 f-dustgrey" [innerHtml]="footer.copyright"></div>
            </div>
            <div class="powered-by">
                <div><a class="link1 link-white" (click)="goToTop()">Go to top</a></div>
            </div>
        </div>
        <div *ngIf="screenWidth > 1024" class="footer-bottom-content footer-last" [ngClass]="{'fade-content':fadeContentLink}">
            <div class="copyright-content">
                <div class="paragraph2 f-dustgrey" [innerHtml]="footer.powered"></div>
            </div>
        </div>
    </div>
    <div class="view-port-detect" 
    inViewport
    [inViewportOptions]="{ threshold: 0.0001 }"
    (inViewportAction)="onIntersection($event)">
    </div>
</footer>

